import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

function OAuthSuccess() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (user) {
        // User is authenticated — go to dashboard (which checks onboarding)
        navigate("/professional-dashboard", { replace: true });
      } else {
        // No session found after OAuth — something went wrong, go to login
        navigate("/login", { replace: true });
      }
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-cyan-500" />
      <p className="text-muted-foreground">Signing you in...</p>
    </div>
  );
}

export default OAuthSuccess;
